import RingRSESchedulingServiceClient from '@amzn/ring-rse-scheduling-service-typescript-client';

import { getBaseApiPathOrigin } from 'utils/url';

export const client = new RingRSESchedulingServiceClient(getBaseApiPathOrigin());
